<template>
  <div style="padding-left: 10px; padding-top: 20px" class="productEdit">
    <div
      class="productEditMc"
      v-show="productEditMcShow"
      @click="
        () => {
          stateVisible = true;
        }
      "
    ></div>
    <ul class="breadcrumb">
      <li>{{ $t("productEdit.breadcrumb1") }}</li>
      <li>{{ $t("productEdit.breadcrumb2") }}</li>
    </ul>
    <p class="head-title">
      <i></i>{{ $t("productEdit.breadcrumb3")
      }}<span>({{ $t("productEdit.breadcrumbTips") }})</span>
    </p>
    <el-form :model="form" label-width="auto" class="form-box">
      <el-form-item :label="$t('productEdit.productCategory')" required>
        <ul class="breadcrumb inline">
          <template v-if="form.classes.length">
            <li v-for="item in form.classes" :key="item.id">{{ item.name }}</li>
          </template>
          <template v-else>
            <li>{{ $t("productEdit.unselect") }}</li>
          </template>
        </ul>
        <el-button
          type="primary"
          size="mini"
          round
          @click="handleChangeClass"
          >{{ $t("productEdit.editCategory") }}</el-button
        >
      </el-form-item>
      <!-- <el-form-item label="贸易类型" required>
        <el-radio-group v-model="form.radio">
          <el-radio :label="1">零售</el-radio>
          <el-radio :label="2">大宗贸易</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="起订量：" required v-if="form.radio == 2">
        <el-input v-model="form.MOQ" class="textfield"></el-input>
      </el-form-item> -->
      <el-form-item :label="$t('productEdit.productName')" required>
        <el-input
          :placeholder="$t('productEdit.productPlaceHolder')"
          v-model="form.title"
          class="textfield"
          maxlength="64"
          clearable
        ></el-input>
        <span class="desc wrap">{{ $t("productEdit.productNote") }}</span>
      </el-form-item>
      <!-- <el-form-item label="副标题：">
        <el-input
          placeholder="请输入副标题"
          v-model="form.subtitle"
          class="textfield"
          maxlength="64"
          clearable
        ></el-input>
        <span class="desc wrap">副标题最多64个字符</span>
      </el-form-item>-->
      <el-form-item :label="$t('productEdit.keyword')">
        <div
          class="keyword-tags"
          v-if="form.keywords && form.keywords.length > 0"
        >
          <el-tag
            v-for="keyword in form.keywords"
            :key="keyword"
            closable
            :disable-transitions="false"
            effect="plain"
            @close="handleDeleteKeywork(keyword)"
            >{{ keyword }}</el-tag
          >
        </div>
        <el-input
          class="input-new-keyword"
          v-if="inputKeywordVisible"
          v-model="inputKeywordValue"
          ref="saveKeywordInput"
          size="small"
          @keyup.enter.native="handleKeywordInputConfirm"
          @blur="handleKeywordInputConfirm"
        ></el-input>
        <el-button
          v-else
          class="button-new-keyword"
          size="small"
          @click="handleShowKeywordInput"
          >{{ $t("productEdit.createKeyword") }}</el-button
        >
        <span class="desc wrap">{{ $t("productEdit.keywordNote") }}</span>
      </el-form-item>
      <!-- <el-form-item label="原价："
                    required>
        <el-input placeholder="请输入原价"
                  v-model="form.originalPrice"
                  class="textfield small"
                  clearable>
          <i slot="prefix"
             class="prefix">$</i>
        </el-input>
        <span class="desc">以美元做单位</span>
      </el-form-item>
      <el-form-item label="现价："
                    required>
        <el-input placeholder="请输入现价"
                  v-model="form.currentPrice"
                  class="textfield small"
                  clearable>
          <i slot="prefix"
             class="prefix">$</i>
        </el-input>
        <span class="desc">以美元做单位</span>
      </el-form-item>-->
      <!-- <el-form-item required label="基础销量：">
        <el-input
          placeholder="请输入基础销量"
          v-model.number="form.sales"
          class="textfield small"
          clearable
        >
          <i slot="suffix" class="suffix">件</i>
        </el-input>
      </el-form-item>-->
      <el-form-item required :label="$t('productEdit.weight')">
        <el-input
          :placeholder="$t('productEdit.weightPlaceholder')"
          v-model="form.weight"
          oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
          class="textfield small"
          clearable
        ></el-input>
        <span class="desc"
          ><span class="red-text">{{ $t("productEdit.kilogram") }}</span
          >（{{ $t("productEdit.kilogramNote") }}）</span
        >
      </el-form-item>
      <el-form-item required :label="$t('productEdit.volume')">
        {{ $t("productEdit.long") }}
        <el-input
          v-model="form.long"
          oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}"
          @change="onChangeVolume"
          class="textfield mini"
        ></el-input>
        <span class="unit red-text">m</span>
        {{ $t("productEdit.width") }}
        <el-input
          oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}"
          @change="onChangeVolume"
          v-model="form.wide"
          class="textfield mini"
        ></el-input>
        <span class="unit red-text">m</span>
        {{ $t("productEdit.height") }}
        <el-input
          oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}"
          @change="onChangeVolume"
          v-model="form.height"
          class="textfield mini"
        ></el-input>
        <span class="unit red-text">m</span>=
        <el-input
          v-model="form.volume"
          :placeholder="$t('productEdit.packageVolume')"
          oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}"
          :disabled="true"
          @change="onChangeVolume"
          class="textfield small"
        ></el-input>
        <span class="desc"
          ><span class="red-text">m&sup3;</span>（{{
            $t("productEdit.precision")
          }}）</span
        >
      </el-form-item>
      <el-form-item :label="$t('productEdit.descriptions')">
        <el-input
          type="textarea"
          :rows="7"
          :placeholder="$t('productEdit.descriptionsNote')"
          v-model="form.descriptions"
          class="small-textarea"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item required :label="$t('productEdit.uploadPhoto')">
        <uploader
          style="margin-top: 10px"
          :urls="form.photoUrls"
          :type="'photo'"
          @change="handlePhotosChanged"
          @top="handlePhotosTop"
          ref="photoUploader"
        ></uploader>
        <span class="desc wrap">{{ $t("productEdit.uploadPhotoNote") }}</span>
      </el-form-item>
      <el-form-item :label="$t('productEdit.uploadVideo')">
        <uploader
          style="margin-top: 10px"
          :videoUrl="form.productVideo"
          :type="'video'"
          @change="handleVideoChanged"
          ref="videoUploader"
        ></uploader>
        <span class="desc wrap">{{ $t("productEdit.uploadVideoNote") }}</span>
      </el-form-item>

      <p class="head-title"><i></i>{{ $t("productEdit.brandTitle") }}</p>
      <div class="gray-box">
        <el-form-item
          :label="$t('productEdit.brandText')"
          style="margin-left: 20px"
        >
          <div class="tag-box" style="margin-left: 50px">
            <el-radio-group v-model="form.isBrandProduct">
              <el-radio :label="1">{{ $t("B2C.yes") }}</el-radio>
              <el-radio :label="0">{{ $t("B2C.no") }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item
          required
          :label="$t('productEdit.brandLogo')"
          class="att-form-item"
          v-if="form.isBrandProduct"
        >
          <uploader
            :urls="form.brandLogo"
            :type="'photo'"
            :max="18"
            @change="brandLogoPhotosChanged"
            @top="brandLogoPhotosTop"
            ref="brandLogoUploader"
          ></uploader>
        </el-form-item>

        <el-form-item
          required
          :label="$t('productEdit.brandAuth')"
          class="att-form-item"
          v-if="form.isBrandProduct"
        >
          <uploader
            :urls="form.brandAuthorizationLetter"
            :type="'photo'"
            :max="18"
            @change="brandAuthPhotosChanged"
            @top="brandAuthPhotosTop"
            ref="brandAuthUploader"
          ></uploader>
        </el-form-item>

        <el-form-item
          required
          :label="$t('productEdit.trademark')"
          class="att-form-item"
          v-if="form.isBrandProduct"
        >
          <uploader
            :urls="form.trademarkRegistrationCertificate"
            :type="'photo'"
            :max="18"
            @change="trademarkPhotosChanged"
            @top="trademarkPhotosTop"
            ref="trademarkUploader"
          ></uploader>
        </el-form-item>
      </div>

      <p class="head-title"><i></i>{{ $t("productEdit.attTitle") }}</p>
      <div class="gray-box">
        <el-form-item
          :label="$t('productEdit.attText')"
          style="margin-left: 35px"
        >
          <div class="tag-box" style="margin-left: 50px">
            <el-radio-group v-model="form.isAttestationProduct">
              <el-radio :label="1">{{ $t("B2C.yes") }}</el-radio>
              <el-radio :label="0">{{ $t("B2C.no") }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item
          :label="$t('productEdit.attType')"
          style="margin-left: 50px"
          v-if="form.isAttestationProduct"
        >
          <div class="tag-box" style="margin-left: 50px">
            <el-checkbox-group v-model="prductAttIds">
              <el-checkbox
                v-for="(item, index) in attestationTypeList"
                :label="item.ATId"
                :key="index"
                @change="onChangeAtt(item, $event)"
                >{{ item.AttestationName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>

        <template v-if="form.isAttestationProduct">
          <el-form-item
            required
            v-for="(item, index) in form.productAttestationList"
            :key="index"
            :label="item.AttestationName"
            class="att-form-item"
          >
            <uploader
              :urls="item.AttestationPhoto"
              :type="'photo'"
              :max="18"
              @click.native="attPhotosClick(index, item.AttestationName)"
              @change="attPhotosChanged"
              @top="attPhotosTop"
              :ref="'attPhotoUploader' + item.AttestationName"
            ></uploader>

            <el-input
              v-if="item && item.OrderBy == 999"
              type="textarea"
              :rows="2"
              maxlength="50"
              show-word-limit
              v-model="item.OtherAttestationDescribe"
              :placeholder="$t('productEdit.inputRemark')"
              clearable
            ></el-input>
          </el-form-item>
        </template>
      </div>

      <p class="head-title"><i></i>{{ $t("productEdit.nature") }}</p>
      <div class="gray-box">
        <el-form-item :label="$t('productEdit.attribute')">
          <el-checkbox
            v-model="form.Liquid"
            :true-label="1"
            :false-label="0"
            @change="onChange"
            >{{ $t("productEdit.liquid") }}</el-checkbox
          >
          <el-checkbox
            v-model="form.Powder"
            :true-label="1"
            :false-label="0"
            @change="onChange"
            >{{ $t("productEdit.powder") }}</el-checkbox
          >
          <el-checkbox
            v-model="form.Paste"
            :true-label="1"
            :false-label="0"
            @change="onChange"
            >{{ $t("productEdit.paste") }}</el-checkbox
          >
          <el-checkbox
            v-model="form.Charged"
            :true-label="1"
            :false-label="0"
            @change="onChange"
            >{{ $t("productEdit.charged") }}</el-checkbox
          >
          <el-checkbox
            v-model="form.Magnetic"
            :true-label="1"
            :false-label="0"
            @change="onChange"
            >{{ $t("productEdit.magnetic") }}</el-checkbox
          >
          <el-checkbox
            v-model="form.DontBelong"
            :true-label="1"
            :false-label="0"
            @change="onOtherChange"
            >{{ $t("productEdit.dontBelong") }}</el-checkbox
          >
        </el-form-item>
      </div>

      <span v-if="isCouponCustomerActivity">
        <p class="head-title"><i></i>{{ $t("productEdit.couponTitle") }}</p>
        <div class="gray-box">
          <el-form-item
            :label="$t('productEdit.couponText')"
            style="margin-left: 50px"
          >
            <div class="tag-box" style="margin-left: 50px">
              <el-radio-group v-model="form.isCouponProduct">
                <el-radio :label="1">{{ $t("B2C.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("B2C.no") }}</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
      </span>

      <p class="head-title"><i></i>{{ $t("productEdit.specTitle") }}</p>
      <div class="gray-box">
        <!-- <el-form-item label="sku类型：">
          <el-radio-group v-model="form.skuType">
            <el-radio :label="1">文字</el-radio>
            <el-radio :label="2">图片</el-radio>
          </el-radio-group>
        </el-form-item>-->
        <el-form-item :label="$t('productEdit.spec')">
          <div
            class="tag-box"
            v-for="(productClassModel, productClassIndex) in productClassModels"
            :key="productClassModel.PCModelId"
          >
            <el-checkbox
              v-model="productClassModel.Checked"
              @change="menuSelect(productClassModel, productClassIndex)"
              >{{ productClassModel.ModelName }}</el-checkbox
            >
            <div class="tag-checkbox-group">
              <el-checkbox
                v-for="(
                  sonClassModel, index
                ) in productClassModel.SonClassModels"
                :label="sonClassModel.PCModelId"
                :key="sonClassModel.PCModelId"
                v-model="sonClassModel.Checked"
                class="normal-checkbox"
                @change="
                  sonClassSelect(
                    productClassModel,
                    sonClassModel,
                    productClassIndex
                  )
                "
              >
                {{ sonClassModel.ModelName }}
                <i
                  class="checkbox-delete el-icon-close"
                  v-if="sonClassModel.isCustomer"
                  @click.stop.prevent="
                    handleDeleteCustomerProductClassModel(
                      productClassModel,
                      index
                    )
                  "
                ></i>
              </el-checkbox>
              <!-- <el-input class="input-new-tag"
                        v-if="productClassModel.inputVisible"
                        v-model="productClassModel.inputValue"
                        :ref="productClassModel.inputRef"
                        size="small"
                        @keyup.enter.native="handleProductClassModelInputConfirm(productClassModel)"
                        @blur="handleProductClassModelInputConfirm(productClassModel)"></el-input>
              <el-button v-else
                         class="button-new-tag"
                         size="small"
              @click="handleShowProductClassModelInput(productClassModel)">自定义</el-button>-->
              <template class="searchSelectBox" style="margin-left: 4px">
                <el-select
                  v-model="productClassModel.inputValue"
                  :ref="productClassModel.inputRef"
                  @focus="requestSpecAtProductClassModel(productClassModel)"
                  @change="specDidChanged(productClassModel)"
                  filterable
                  remote
                  default-first-option
                  :loading="productClassModel.specLoading"
                  allow-create
                  :placeholder="$t('productEdit.inputSpec')"
                >
                  <!-- :remote-method="(query)=>{loadProductClassModels(query,productClassModel)}" -->
                  <el-option
                    v-for="item in productClassModel.specs"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :label="$t('productEdit.specSettings')"
          required
          style="margin-top: 30px"
          v-if="selectedTableData.length"
        >
          <div style="overflow: hidden">
            <el-table :data="paramTableData" ref="table">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column
                :prop="productClassModel.PCModelId + ''"
                :label="productClassModel.ModelName"
                v-for="productClassModel in selectedTableData"
                :key="productClassModel.PCModelId"
              ></el-table-column>
              <el-table-column :label="$t('productEdit.oPrice')">
                <template slot-scope="scope">
                  <el-input
                    :placeholder="
                      $t('B2C.input') + ' ' + $t('productEdit.oPrice')
                    "
                    class="textfield"
                    style="min-width: auto"
                    v-model="form.originalPrices[scope.row.key]"
                  >
                    <i slot="prefix" class="prefix" style="line-height: 40px"
                      >$</i
                    >
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('productEdit.cPrice')">
                <template slot-scope="scope">
                  <el-input
                    :placeholder="
                      $t('B2C.input') + ' ' + $t('productEdit.cPrice')
                    "
                    class="textfield"
                    style="min-width: auto"
                    v-model="form.currentPrices[scope.row.key]"
                  >
                    <i slot="prefix" class="prefix" style="line-height: 40px"
                      >$</i
                    >
                  </el-input>
                </template>
              </el-table-column>

              <el-table-column :label="$t('productEdit.inventory')">
                <template slot-scope="scope">
                  <el-input
                    :placeholder="
                      $t('B2C.input') + ' ' + $t('productEdit.inventory')
                    "
                    class="textfield"
                    style="min-width: auto"
                    v-model="form.inventory[scope.row.key]"
                    oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"
                  >
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px">
            <el-button round size="small" @click="handleTableAllSelection">{{
              $t("productEdit.selectAll")
            }}</el-button>
            <el-button round size="small" @click="handleTableClearSelection">{{
              $t("productEdit.cancel")
            }}</el-button>
            <el-button
              type="primary"
              round
              size="small"
              @click="handleTableSetPrices"
              >{{ $t("productEdit.setPrice") }}</el-button
            >
            <el-button
              type="primary"
              round
              size="small"
              @click="handleTableSetInventory"
              >{{ $t("productEdit.setInventory") }}</el-button
            >
          </div>
        </el-form-item>
      </div>
      <el-form-item :label="$t('productEdit.onShelfSettings')" required>
        <el-radio-group v-model="form.status">
          <el-radio :label="0">{{ $t("productEdit.deposit") }}</el-radio>
          <el-radio :label="1">{{ $t("productEdit.onShelf") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('productEdit.remark')">
        <el-input
          v-if="tBUrlInputVisible"
          type="textarea"
          :rows="3"
          ref="tBUrlInputVisible"
          :placeholder="$t('productEdit.inputRemark')"
          v-model="form.tBUrl"
          @blur="showPorducttBUrlInput"
          class="tBUrlInput"
          clearable
        ></el-input>
        <div
          v-else
          class="tBUrlInput textareatBUrl"
          style="line-height: 1.25rem"
          @click="showPorducttBUrlInput"
        >
          {{ form.tBUrl }}
        </div>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="handleSubmit" class="submit-btn" round>{{
      $t("productEdit.submit")
    }}</el-button>
    <el-dialog
      :title="freightDialog.title"
      :visible.sync="freightDialog.visible"
      width="75%"
    >
      <carriage-template
        :id="freightDialog.id"
        :stop="true"
        @save="handleFreightModelDidSaved"
        ref="carrigeTemplate"
      ></carriage-template>
    </el-dialog>
    <el-dialog
      :title="$t('productEdit.productCategory')"
      :visible.sync="classesDialogVisible"
      width="75%"
    >
      <prodcut-classes
        :stop="true"
        @save="handleClassesDidSaved"
      ></prodcut-classes>
    </el-dialog>
    <!-- 服务说明 -->
    <el-dialog
      :title="$t('productEdit.explain')"
      class="stateBox"
      :visible.sync="stateVisible"
      width="40%"
      top="35vh"
      :center="true"
    >
      <div slot="title" class="title">{{ $t("productEdit.tips") }}</div>
      <div class="stateInfo">
        {{ $t("productEdit.text1") }}
      </div>
      <!-- <div class="stateInfo" style="margin-top:20px">具体资费标准，请查看<a @click="toTerms" style="color:#0166ff">《Vancheen服务条款》</a>。</div> -->
      <div class="stateInfo2">
        {{ $t("productEdit.text2") }}
      </div>
      <div class="stateInfo2" style="margin-top: 0px">
        {{ $t("productEdit.text3") }}
      </div>
      <div class="btns">
        <el-button
          class="stateInfoBt"
          type="success"
          @click="agreedSub"
          round
          >{{ $t("productEdit.confirm") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AsyncValidator from "async-validator"; // 验证
import CarriageTemplate from "./CarriageTemplate";
import ProdcutClasses from "./ProductClasses";
import { commonMethod } from "../../common/method.js";
const pricePattern = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)|(^[1-9]\d)/;
const floatPattern = /(^[1-9]\d*(\.\d{1,4})?$)|(^0(\.\d{1,4})?$)|(^[1-9]\d)/;

export default {
  name: "ProductEdit",
  components: { CarriageTemplate, ProdcutClasses },
  props: {
    id: {
      type: Number,
      default: 1,
    },
    number: String,
    tburl: String,
  },
  data() {
    return {
      pid: null, //产品id
      currentIndex: 0,
      isCouponCustomerActivity: false, //供应商是否参加优惠活动
      productEditMcShow: false, // 显示服务协议按钮
      stateVisible: false, // 服务说明
      searchSelectList: [],
      loading: false,
      classID: this.id,
      // classID: undefined,
      // classID: 1,
      productNumber: this.number,
      tBUrlInputVisible: true,
      form: {
        // MOQ: "",
        // radio: 1,
        classes: [],
        title: "",
        subtitle: "",
        keywords: [],
        descriptions: "",
        tBUrl: "",
        originalPrice: 0,
        currentPrice: 0,
        sales: 0,
        weight: "",
        long: "",
        wide: "",
        height: "",
        volume: "",
        photoUrls: [],
        productVideo: "",
        freightID: null,
        skuType: 1,
        originalPrices: {},
        currentPrices: {},
        inventory: {},
        status: 0,
        Liquid: 0,
        Powder: 0,
        Paste: 0,
        Charged: 0,
        Magnetic: 0,
        DontBelong: 0,
        isCouponProduct: 0, //是否优惠券产品
        isBrandProduct: 0, //是否品牌产品
        brandLogo: [], //品牌logo
        brandAuthorizationLetter: [], //品牌授权书
        trademarkRegistrationCertificate: [], //商标注册证
        isAttestationProduct: 0, //是否认证产品
        productAttestationList: [], //产品认证集合
      },
      attestationTypeList: [], //认证分类列表
      prductAttIds: [], //认证类型
      uploaders: [],
      rule: {
        /// [\u4E00-\u9FA5\uF900-\uFA2D]/descriptions!pricePattern.test(val)
        descriptions: [
          {
            required: false,
            message: this.$t("productEdit.rule1"),
            validator: (rule, value) => {
              const vail = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
              if (vail.test(value)) {
                return new Error(this.$t("productEdit.rule1"));
              } else {
                console.log(value);
                return true;
              }
            },
          },
        ],
        classes: [
          {
            required: true,
            message: this.$t("productEdit.rule2"),
            validator: (rule, value) => {
              if (value.length === 1 && value[0].id === "1") {
                return new Error(this.$t("productEdit.rule2"));
              } else {
                console.log(value);
                return true;
              }
            },
          },
        ],
        // radio: [
        //   { required: true, message: '请选择贸易类型' },
        // ],
        // MOQ: [
        //   { required: true, message: '请输入起订量' },
        // ],
        title: [
          { required: true, message: this.$t("productEdit.rule3") },
          { max: 64, message: this.$t("productEdit.rule4") },
        ],
        subtitle: { max: 64, message: this.$t("productEdit.rule5") },
        keywords: {
          type: "array",
          max: 10,
          message: this.$t("productEdit.rule6"),
        },
        // originalPrice: [
        //   { required: true, message: '请输入原价' },
        //   { pattern: pricePattern, message: '请输入正确的原价' }
        // ],
        // currentPrice: [
        //   { required: true, message: '请输入现价' },
        //   { pattern: pricePattern, message: '请输入正确的现价' }
        // ],
        sales: [
          { required: true, message: this.$t("productEdit.rule7") },
          { type: "integer", message: this.$t("productEdit.rule8") },
        ],
        weight: [
          { required: true, message: this.$t("productEdit.rule9") },
          { pattern: floatPattern, message: this.$t("productEdit.rule10") },
        ],
        volume: [
          { required: true, message: this.$t("productEdit.rule11") },
          { pattern: floatPattern, message: this.$t("productEdit.rule12") },
        ],
        photoUrls: [
          {
            type: "array",
            required: true,
            message: this.$t("productEdit.rule13"),
          },
          {
            type: "array",
            min: 3,
            max: 10,
            message: this.$t("productEdit.rule14"),
          },
        ],
        // freightID: { required: true, message: '请选择运费模板' },
        originalPrices: {
          validator: (rule, value, callback, source, options) => {
            for (const item of this.paramTableData) {
              const val = value[item.key];
              if (val) {
                console.log(val <= 0.1);
                if (!pricePattern.test(val) || val <= 0.1) {
                  // return new Error('请正确填写商品规格的各个原价')

                  if (!pricePattern.test(val))
                    return new Error(this.$t("productEdit.rule15"));
                  if (val <= 0.1)
                    return new Error(this.$t("productEdit.rule16"));
                }
              } else {
                return new Error(this.$t("productEdit.rule17"));
              }
            }
            return true;
          },
        },
        currentPrices: {
          validator: (rule, value, callback, source, options) => {
            for (const item of this.paramTableData) {
              const val = value[item.key];
              if (val) {
                if (!pricePattern.test(val) || val <= 0.1) {
                  // return new Error('请正确填写商品规格的各个现价')
                  if (!pricePattern.test(val))
                    return new Error(this.$t("productEdit.rule18"));
                  if (val <= 0.1)
                    return new Error(this.$t("productEdit.rule19"));
                }
              } else {
                return new Error(this.$t("productEdit.rule20"));
              }
            }
            return true;
          },
        },
        inventory: {
          validator: (rule, value, callback, source, options) => {
            for (const item of this.paramTableData) {
              const val = value[item.key];
              if (!val || val == 0) {
                return new Error(this.$t("productEdit.promptInventory"));
              }
            }
            return true;
          },
        },
        // brandLogo: [
        //   {
        //     type: "array",
        //     required: true,
        //     message:
        //       this.$t("productEdit.upload") +
        //       " " +
        //       this.$t("productEdit.brandLogo"),
        //   },
        //   {
        //     type: "array",
        //     min: 1,
        //     max: 18,
        //     message: this.$t("productEdit.rule21"),
        //   },
        // ],
        // brandAuthorizationLetter: [
        //   {
        //     type: "array",
        //     required: true,
        //     message:
        //       this.$t("productEdit.upload") +
        //       " " +
        //       this.$t("productEdit.brandAuth"),
        //   },
        //   {
        //     type: "array",
        //     min: 1,
        //     max: 18,
        //     message: this.$t("productEdit.rule21"),
        //   },
        // ],
        // trademarkRegistrationCertificate: [
        //   {
        //     type: "array",
        //     required: true,
        //     message:
        //       this.$t("productEdit.upload") +
        //       " " +
        //       this.$t("productEdit.trademark"),
        //   },
        //   {
        //     type: "array",
        //     min: 1,
        //     max: 18,
        //     message: this.$t("productEdit.rule21"),
        //   },
        // ],
      },
      inputKeywordVisible: false,
      inputKeywordValue: "",
      freightModels: [],
      productClassModels: [],
      freightDialog: {
        visible: false,
        id: null,
        title: null,
      },
      classesDialogVisible: false,
    };
  },
  computed: {
    selectedFreightModel() {
      return this.freightModels.find((freight) => {
        return freight.CFMId === this.form.freightID;
      });
    },
    selectedFreightModelCityName() {
      if (!this.selectedFreightModel) return "";
      if (this.selectedFreightModel.IsFree) {
        return "全球";
      }
      return this.selectedFreightModel.DefultFreightModelInfo.CityName;
    },
    selectedFreightModelDescript() {
      if (!this.selectedFreightModel) return "";
      let firstCount, firstPrict, addCount, addPrice;
      if (this.selectedFreightModel.IsFree) {
        firstCount = 1;
        firstPrict = this.formatPrice(0);
        addCount = 1;
        addPrice = this.formatPrice(0);
      } else {
        firstCount = this.selectedFreightModel.DefultFreightModelInfo.ItemCount;
        firstPrict = this.formatPrice(
          this.selectedFreightModel.DefultFreightModelInfo.ItemPrice
        );
        addCount = this.selectedFreightModel.DefultFreightModelInfo.AddNumber;
        addPrice = this.formatPrice(
          this.selectedFreightModel.DefultFreightModelInfo.AddPrice
        );
      }
      return this.$t("productEdit.addText", {
        firstCount: firstCount,
        firstPrict: firstPrict,
        addCount: addCount,
        addPrice: addPrice,
      });
    },
    selectedTableData() {
      return this.productClassModels.filter(
        (c) => c.Checked && c.SonClassModels.findIndex((s) => s.Checked) !== -1
      );
    },
    paramTableData() {
      let arr = [];
      // console.log(this.selectedTableData)
      for (const item of this.selectedTableData) {
        arr.push(item.SonClassModels.filter((s) => s.Checked));
      }
      return this.reduceProductClassModels(arr);
    },
  },
  watch: {},
  mounted() {
    if (this.productNumber === undefined) {
      this.requestFormData();
    } else {
      this.requestProduct();
    }
    // const ref = this.$refs.table
    // if (ref) {
    this.$nextTick((_) => {
      setTimeout((_) => {
        this.handleTableAllSelection();
      }, 200);
    });
    // }
    // setTimeout(_ => { this.handleTableAllSelection() }, 200)
    // 20200523检测用户是否同意协议
    let agreedState = JSON.parse(localStorage.getItem("agreedState"));
    console.log(agreedState);
    if (!agreedState) {
      this.stateVisible = true;
      this.productEditMcShow = true;
      // return false
    }
  },
  methods: {
    onChangeAtt(val, check) {
      var item = this.form.productAttestationList.find(
        (p) => p.ATId == val.ATId
      );
      var idx = this.form.productAttestationList.findIndex(
        (p) => p.ATId == val.ATId
      );
      if (check) {
        if (!item) {
          this.form.productAttestationList.push({
            PId: this.pid,
            OrderBy: val.OrderBy,
            ATId: val.ATId,
            AttestationName: val.AttestationName,
            AttestationPhoto: [],
            OtherAttestationDescribe: "",
          });
        }
      } else {
        if (item) {
          this.form.productAttestationList.splice(idx, 1);
        }
      }
    },
    onChangeVolume() {
      if (this.form.long && this.form.wide && this.form.height) {
        this.form.volume = this.form.long * this.form.wide * this.form.height;
        this.form.volume = parseFloat(this.form.volume).toFixed(3);
      } else {
        this.form.volume = "";
      }
    },
    onChange() {
      if (
        this.form.Liquid ||
        this.form.Powder ||
        this.form.Paste ||
        this.form.Charged ||
        this.form.Magnetic
      ) {
        this.form.DontBelong = 0;
      }
    },
    onOtherChange() {
      if (this.form.DontBelong) {
        this.form.Liquid = 0;
        this.form.Powder = 0;
        this.form.Paste = 0;
        this.form.Charged = 0;
        this.form.Magnetic = 0;
      }
    },
    // 更新规格状态
    updateproductClass() {
      let newProductClassModels = this.productClassModels;
      newProductClassModels.forEach((productClassModel, productClassIndex) => {
        let productChecked = false;
        productChecked = productClassModel.SonClassModels.some((item) => {
          return item.Checked === true;
        });
        productClassModel.SonClassModels.length === 0 &&
          (productChecked = false);
        newProductClassModels[productClassIndex].Checked = productChecked;
      });
      this.productClassModels = newProductClassModels;
      // let aa = this.productClassModels.filter(
      //   c => c.Checked && c.SonClassModels.findIndex(s => s.Checked) !== -1
      // )
      // console.log(aa)
      // 价格全选
      // this.handleTableAllSelection()

      //this.setDefaultInventory();
    },
    setDefaultInventory() {
      setTimeout(() => {
        const selectedData = this.$refs.table.data;
        for (const data of selectedData) {
          if (!this.form.inventory[data.key])
            this.$set(this.form.inventory, data.key, 100);
        }
      });
    },
    // 选择类别
    menuSelect(productClassModel) {
      if (productClassModel.Checked === true) {
        productClassModel.SonClassModels.forEach((item) => {
          item.Checked = true;
        });
      } else {
        productClassModel.SonClassModels.forEach((item) => {
          item.Checked = false;
        });
      }
    },
    // 选择规格
    sonClassSelect(productClassModel, sonClassModel, productClassIndex) {
      let productChecked = false;
      productChecked = productClassModel.SonClassModels.some((item) => {
        return item.Checked === true;
      });
      this.productClassModels[productClassIndex].Checked = productChecked;
      console.log(productChecked);
    },
    // remoteMethod (query, productClassModel) {
    //   console.log(query)
    //   console.log(productClassModel)
    // },
    requestProduct() {
      this.$api.product
        .getProductsByNumber({
          ProductNumber: this.productNumber,
        })
        .then((res) => {
          const data = res.data;
          const product = data.LoadProduct;
          this.pid = product.PId;
          this.isCouponCustomerActivity = product.IsCouponCustomerActivity;
          let classes = [];
          const ids = data.LoadProductsClassBySelect.ClassIdList.split("|");
          const names =
            data.LoadProductsClassBySelect.ClassIdListName.split("|");
          for (let i = 0; i < ids.length; i++) {
            const id = ids[i];
            const name = names[i];
            classes.push({
              id,
              name,
            });
          }
          this.form.classes = classes;
          this.freightModels = data.ListLoadCustomerFreightModel;
          this.attestationTypeList = data.AttestationTypeList;
          // 2020
          this.productClassModels = product.ListClassModels.map((item) => {
            item.inputVisible = false;
            item.inputValue = "";
            item.inputRef = "input" + item.PCModelId;
            item.Checked = item.Checked !== 0;
            const SonClassModels = [];
            for (const son of item.SonClassModels) {
              if (son.Checked !== 0) {
                son.Checked = true;
                SonClassModels.push(son);
              }
            }
            item.SonClassModels = SonClassModels;
            return item;
          });
          // 数据填充
          this.classID = product.ClassId;
          this.form.title = product.ProductName;
          this.form.subtitle = product.ProductSTitle;
          this.form.keywords = product.KeyWord
            ? product.KeyWord.split(",")
            : [];
          this.form.descriptions = product.Descriptions;
          this.form.tBUrl = product.TBUrl;
          this.form.originalPrice = product.OriginalPrice;
          this.form.currentPrice = product.CurrentPrice;
          this.form.sales = product.Sales;
          this.form.weight = product.Weight;
          this.form.volume = product.Volume;
          this.form.photoUrls = product.ProductPhoto.split("|");
          this.form.productVideo = product.ProductVideo;
          this.form.freightID = product.CFMId;
          this.form.status = product.Status;
          this.form.Liquid = product.Liquid;
          this.form.Powder = product.Powder;
          this.form.Paste = product.Paste;
          this.form.Charged = product.Charged;
          this.form.Magnetic = product.Magnetic;
          this.form.DontBelong = product.DontBelong;
          this.form.isCouponProduct = product.IsCouponProduct;
          //品牌
          this.form.isBrandProduct = product.IsBrandProduct;
          this.form.brandLogo = product.BrandLogo
            ? product.BrandLogo.split("|")
            : [];
          this.form.brandAuthorizationLetter = product.BrandAuthorizationLetter
            ? product.BrandAuthorizationLetter.split("|")
            : [];
          this.form.trademarkRegistrationCertificate =
            product.TrademarkRegistrationCertificate
              ? product.TrademarkRegistrationCertificate.split("|")
              : [];

          //认证
          this.form.isAttestationProduct = product.IsAttestationProduct;
          let productAttestationList = [];
          if (product.ProductAttestationList.length > 0) {
            for (var productAtt of product.ProductAttestationList) {
              var att = productAtt;
              att.AttestationPhoto = att.AttestationPhoto.split("|");
              productAttestationList.push(productAtt);
            }

            this.form.productAttestationList = productAttestationList;

            this.prductAttIds = [];
            var attItems = this.form.productAttestationList.filter(
              (p) => p.ATId
            );
            for (var att of attItems) {
              this.prductAttIds.push(att.ATId);
              this.uploaders.push("attPhotoUploader" + att.AttestationName);
            }
          }

          let originalPrices = {};
          let currentPrices = {};
          let inventory = {};
          this.form.tBUrl !== "" && (this.tBUrlInputVisible = false);
          for (const item of product.ListViewProductModelPriceOrIMG) {
            originalPrices[item.PCModelId] = item.CNOriginalPrice;
            currentPrices[item.PCModelId] = item.CNCurrentPrice;
            inventory[item.PCModelId] = item.Inventory;
          }
          // console.log(originalPrices)商品原价与现价
          // console.log(currentPrices)
          this.form.originalPrices = originalPrices;
          this.form.currentPrices = currentPrices;
          this.form.inventory = inventory;
          this.$nextTick((_) => {
            this.$refs.photoUploader.reloadData();
            this.$refs.videoUploader.reloadVideosData();
            //品牌
            if (this.form.brandLogo && this.form.brandLogo.length > 0) {
              this.$refs.brandLogoUploader.reloadData();
            }
            if (
              this.form.brandAuthorizationLetter &&
              this.form.brandAuthorizationLetter.length > 0
            ) {
              this.$refs.brandAuthUploader.reloadData();
            }
            if (
              this.form.trademarkRegistrationCertificate &&
              this.form.trademarkRegistrationCertificate.length > 0
            ) {
              this.$refs.trademarkUploader.reloadData();
            }
            //认证
            if (this.uploaders && this.uploaders.length > 0) {
              for (var upload of this.uploaders) {
                this.$refs[upload][0].reloadData();
              }
            }
          });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    requestFormData() {
      this.$api.product
        .loadAddProductData({
          SonClassId: this.classID,
          ProductClassId: this.classID,
        })
        .then((res) => {
          const data = res.data;
          let classes = [];
          const ids = data.LoadProductsClassBySelect.ClassIdList.split("|");
          const names =
            data.LoadProductsClassBySelect.ClassIdListName.split("|");
          for (let i = 0; i < ids.length; i++) {
            const id = ids[i];
            const name = names[i];
            classes.push({
              id,
              name,
            });
          }
          this.form.classes = classes;
          this.freightModels = data.ListLoadCustomerFreightModel;
          this.productClassModels = data.ListViewProductClassModels.map(
            (item) => {
              item.inputVisible = false;
              item.inputValue = "";
              item.inputRef = "input" + item.PCModelId;
              item.Checked = item.Checked !== 0;
              item.SonClassModels = [];
              // item.SonClassModels = item.SonClassModels.map(son => {
              //   son.Checked = son.Checked !== 0
              //   return son
              // })
              return item;
            }
          );
          this.isCouponCustomerActivity = data.IsCouponCustomerActivity;
          this.attestationTypeList = data.AttestationTypeList;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    requestPrdouctClass() {
      if (this.classID) {
        this.$api.product
          .getProductsClassBySelect({
            SonClassId: this.classID,
          })
          .then((res) => {
            const data = res.data;
            let classes = [];
            const ids = data.ClassIdList.split("|");
            const names = data.ClassIdListName.split("|");
            for (let i = 0; i < ids.length; i++) {
              const id = ids[i];
              const name = names[i];
              classes.push({
                id,
                name,
              });
            }
            this.form.classes = classes;
          });
      }
    },
    requestProductClassModels() {
      let param = {};
      if (this.classID) {
        param.ProductClassId = this.classID;
      }
      this.$api.product.loadProductClassModels(param).then((res) => {
        console.log(res.data);
      });
    },
    requestFreightModels() {
      this.$api.customer.loadCustomerFreightModel().then((res) => {
        this.freightModels = res.data;
      });
    },
    handleChangeClass() {
      this.classesDialogVisible = true;
    },
    handleDeleteKeywork(keyword) {
      this.form.keywords.splice(this.form.keywords.indexOf(keyword), 1);
    },
    handleShowKeywordInput() {
      this.inputKeywordVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveKeywordInput.$refs.input.focus();
      });
    },
    handleKeywordInputConfirm() {
      let inputValue = this.inputKeywordValue;
      if (inputValue) {
        if (this.form.keywords.indexOf(inputValue) === -1) {
          this.form.keywords.push(inputValue);
        } else {
          this.$message.error(this.$t("productEdit.error1"));
        }
      }
      this.inputKeywordVisible = false;
      this.inputKeywordValue = "";
    },
    handleShowProductClassModelInput(productClassModel) {
      productClassModel.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs[productClassModel.inputRef][0].$refs.input.focus();
      });
    },
    handleProductClassModelInputConfirm(productClassModel) {
      const inputValue = productClassModel.inputValue;
      if (inputValue) {
        if (
          productClassModel.SonClassModels.findIndex(
            (item) => item.ModelName === inputValue
          ) === -1
        ) {
          inputValue.forEach((item) => {
            productClassModel.SonClassModels.push({
              Checked: 0,
              ModelName: item,
              PCModelId: parseInt(
                (Date.now() + "").substr(-6) +
                  ("0000" + Math.floor(Math.random() * 10000)).slice(-4)
              ),
              ParentId: productClassModel.PCModelId,
              isCustomer: true,
            });
          });
          this.loadProductClassModels("", productClassModel);
          // productClassModel.SonClassModels.push({
          //   Checked: 0,
          //   ModelName: inputValue,
          //   PCModelId: parseInt((Date.now() + '').substr(-6) + ('0000' + Math.floor(Math.random() * 10000)).slice(-4)),
          //   ParentId: productClassModel.PCModelId,
          //   isCustomer: true
          // })
        } else {
          this.$message.error(
            this.$t("productEdit.error2") + productClassModel.ModelName
          );
        }
      }
      productClassModel.inputVisible = false;
      productClassModel.inputValue = "";
    },
    handleDeleteCustomerProductClassModel(productClassModel, index) {
      productClassModel.SonClassModels.splice(index, 1);
      // 更新状态
      this.updateproductClass();
    },
    handlePhotosChanged(images) {
      this.form.photoUrls = images.map((image) => {
        return image.state === "success" ? image.url : "";
      });
    },
    handlePhotosTop(images) {
      this.form.photoUrls = images.map((image) => {
        return image.state === "success" ? image.origin : "";
      });
    },
    handleVideoChanged(videos) {
      if (videos[0] && videos[0].state === "success") {
        this.form.productVideo = videos[0].url;
      } else {
        this.form.productVideo = "";
      }
    },
    handleAddFreightModels() {
      this.freightDialog.title = this.$t("productEdit.addFreightTitle");
      this.freightDialog.id = null;
      const ref = this.$refs.carrigeTemplate;
      if (ref) {
        this.$nextTick((_) => {
          ref.refreshUI();
        });
      }
      this.freightDialog.visible = true;
    },
    handleEditFreightModels() {
      this.freightDialog.title = this.$t("productEdit.editFreightTitle");
      this.freightDialog.id = this.form.freightID;
      const ref = this.$refs.carrigeTemplate;
      if (ref) {
        this.$nextTick((_) => {
          ref.refreshUI();
        });
      }
      this.freightDialog.visible = true;
    },
    handleFreightModelDidSaved() {
      this.requestFreightModels();
      this.freightDialog.visible = false;
    },
    handleClassesDidSaved(productClass) {
      this.classID = productClass.ClassId;
      this.requestFormData();
      this.classesDialogVisible = false;
    },
    handleTableAllSelection() {
      const table = this.$refs.table;
      table && table.clearSelection();
      table && table.toggleAllSelection();
    },
    handleTableClearSelection() {
      const table = this.$refs.table;
      table.clearSelection();
    },
    handleTableSetPrices() {
      const selectedData = this.$refs.table.selection;
      if (selectedData.length === 0) {
        this.$message({
          type: "warning",
          message: this.$t("productEdit.messageSpec"),
        });
        return;
      }
      this.$prompt(this.$t("productEdit.promptPrice"), {
        confirmButtonText: this.$t("productEdit.confirm"),
        cancelButtonText: this.$t("productEdit.cancel"),
        inputPattern: pricePattern,
        inputErrorMessage: this.$t("productEdit.formatPrice"),
      }).then(({ value }) => {
        for (const data of selectedData) {
          this.$set(this.form.originalPrices, data.key, value);
          this.$set(this.form.currentPrices, data.key, value);
        }
      });
    },
    handleTableSetInventory() {
      const selectedData = this.$refs.table.selection;
      if (selectedData.length === 0) {
        this.$message({
          type: "warning",
          message: this.$t("productEdit.messageSpec"),
        });
        return;
      }
      this.$prompt(this.$t("productEdit.promptInventory"), {
        confirmButtonText: this.$t("productEdit.confirm"),
        cancelButtonText: this.$t("productEdit.cancel"),
        inputPattern: floatPattern,
        inputErrorMessage: this.$t("productEdit.formatInventory"),
      }).then(({ value }) => {
        for (const data of selectedData) {
          this.$set(this.form.inventory, data.key, value);
        }
      });
    },
    // 同意协议
    agreedSub() {
      localStorage.setItem("agreedState", false);
      this.stateVisible = false;
      this.productEditMcShow = false;
    },
    handleSubmit() {
      const validator = new AsyncValidator(this.rule);
      validator
        .validate(this.form)
        .then((_) => {
          let productModels = [];
          for (const item of this.productClassModels) {
            productModels.push({
              PCModelId: item.PCModelId,
              ClassId: this.classID,
              ParentId: 0,
              ModelName: item.ModelName,
              Checked: item.Checked && item.SonClassModels.length > 0 ? 1 : 0,
            });
            for (const son of item.SonClassModels) {
              productModels.push({
                PCModelId: son.PCModelId,
                ClassId: this.classID,
                ParentId: son.ParentId,
                ModelName: son.ModelName,
                Checked: son.Checked ? 1 : 0,
              });
            }
          }
          let selectedTableData = this.selectedTableData.every(
            (item) => item.SonClassModels
          );
          if (this.selectedTableData.length === 0 || !selectedTableData) {
            this.$message.error(this.$t("productEdit.error3"));
            return false;
          }
          let productModelPrices = [];
          for (const item of this.paramTableData) {
            productModelPrices.push({
              PCModelId: item.key,
              CNOriginalPrice: this.form.originalPrices[item.key],
              CNCurrentPrice: this.form.currentPrices[item.key],
              Inventory: this.form.inventory[item.key],
            });
          }
          let productAttestationList = [];
          if (this.form.productAttestationList.length > 0) {
            for (var productAtt of this.form.productAttestationList) {
              var att = commonMethod.deepClone(productAtt);
              att.AttestationPhoto = att.AttestationPhoto.join("|");
              productAttestationList.push(att);
            }
          }
          let param = {
            ClassId: this.classID,
            OriginalPrice: 0,
            CurrentPrice: 0,
            Sales: this.form.sales,
            Weight: this.form.weight,
            Volume: this.form.volume,
            ProductPhoto: this.form.photoUrls.join("|"),
            ProductVideo: this.form.productVideo,
            Status: this.form.status,
            ProductName: this.form.title,
            ProductSTitle: this.form.subtitle,
            KeyWord: this.form.keywords ? this.form.keywords.join(",") : [],
            Descriptions: this.form.descriptions,
            TBUrl: this.form.tBUrl,
            CFMId: 0,
            ListAddProductModels: productModels,
            ListModelsPriceOrIMG: productModelPrices,
            Liquid: this.form.Liquid,
            Powder: this.form.Powder,
            Paste: this.form.Paste,
            Charged: this.form.Charged,
            Magnetic: this.form.Magnetic,
            DontBelong: this.form.DontBelong,
            IsCouponProduct: this.form.isCouponProduct,
            //品牌
            IsBrandProduct: this.form.isBrandProduct,
            BrandLogo: this.form.brandLogo.join("|"),
            BrandAuthorizationLetter:
              this.form.brandAuthorizationLetter.join("|"),
            TrademarkRegistrationCertificate:
              this.form.trademarkRegistrationCertificate.join("|"),
            //认证
            IsAttestationProduct: this.form.isAttestationProduct,
            ProductAttestationList: productAttestationList,
          };
          if (this.productNumber) {
            param.ProductNumber = this.productNumber;
          }
          if (this.tburl) {
            param.TBUrl = this.tburl;
          }
          this.submit(param);
        })
        .catch(({ errors }) => {
          this.$message.error(errors[0].message);
        });
    },
    submit(param) {
      this.$api.product
        .addProducts(param)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: this.$t("productEdit.submitSuccess"),
              type: "success",
            });
            setTimeout((_) => {
              this.$router.replace({
                name: "products",
              });
            }, 500);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    reduceProductClassModels(arr = []) {
      if (arr.length === 0) return arr;
      return arr.reduce((res, currentItem) => {
        let _arr = [];
        if (res.length === 0) {
          currentItem.forEach((item) => {
            let obj = {
              key: item.PCModelId + "",
            };
            obj[item.ParentId] = item.ModelName;
            _arr.push(obj);
          });
        } else {
          res.forEach((item1) => {
            if (currentItem.length === 0) {
              let obj = JSON.parse(JSON.stringify(item1));
              _arr.push(obj);
            } else {
              currentItem.forEach((item2) => {
                let obj = JSON.parse(JSON.stringify(item1));
                obj[item2.ParentId] = item2.ModelName;
                obj.key = obj.key + "|" + item2.PCModelId;
                _arr.push(obj);
              });
            }
          });
        }
        return _arr;
      }, []);
    },
    // reduceTow (source1, source2) {
    //   source1.ii
    // },
    formatPrice(val) {
      var str = val.toFixed(2) + "";
      var intSum = str
        .substring(0, str.indexOf("."))
        .replace(/\B(?=(?:\d{3})+$)/g, ","); // 取到整数部分
      var dot = str.substring(str.length, str.indexOf(".")); // 取到小数部分搜索
      var ret = intSum + dot;
      return ret;
    },
    showPorducttBUrlInput() {
      this.form.tBUrl !== "" &&
        (this.tBUrlInputVisible = !this.tBUrlInputVisible);
      this.tBUrlInputVisible &&
        this.form.tBUrl !== "" &&
        this.$nextTick((_) => {
          this.$refs.tBUrlInputVisible.focus();
        });
    },
    loadProductClassModels(value, productClassModel) {
      console.log(productClassModel);

      let params = {
        ProductClassId: this.id,
        ParentId: productClassModel.PCModelId,
        SreachValues: value,
      };
      (!value || value === "") && delete params.SreachValues;
      this.$api.product
        .loadProductClassModels(params)
        .then((res) => {
          console.log(res);
          const data = res.data;
          let newSearchSelectList = [];
          data.forEach((item) => {
            if (
              productClassModel.SonClassModels.findIndex(
                (newItem) => newItem.ModelName === item.ModelName
              ) === -1
            ) {
              newSearchSelectList.push({
                value: item.ModelName,
                label: item.ModelName,
              });
            }
          });
          this.searchSelectList = newSearchSelectList;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 20-01-15
    specDidChanged(productClassModel) {
      //console.log(productClassModel);
      const value = productClassModel.inputValue;
      //console.log(productClassModel.inputValue.length, "length");
      if (productClassModel.inputValue.length > 40) {
        this.$message.error(this.$t("productEdit.error4"));
        return false;
      }
      let spec;
      const index = productClassModel.specs.findIndex((v) => {
        return v.value === value;
      });
      // 查询specs下是否有选择项
      const selectedSpec = index === -1 ? null : productClassModel.specs[index];
      if (selectedSpec) {
        spec = {
          Checked: true,
          ModelName: selectedSpec.label,
          PCModelId: selectedSpec.value,
          ParentId: productClassModel.PCModelId,
          isCustomer: true,
        };
        productClassModel.specs.splice(index, 1);
      } else {
        spec = {
          Checked: true,
          ModelName: value,
          PCModelId: parseInt(
            (Date.now() + "").substr(-6) +
              ("0000" + Math.floor(Math.random() * 10000)).slice(-4)
          ),
          ParentId: productClassModel.PCModelId,
          isCustomer: true,
        };
      }
      if (
        productClassModel.SonClassModels.findIndex((x) => {
          return x.ModelName === spec.ModelName;
        }) === -1
      ) {
        productClassModel.SonClassModels.push(spec);
      } else {
        this.$message.error(
          this.$t("productEdit.error2") + productClassModel.ModelName
        );
      }

      productClassModel.inputValue = null;
      // 更新状态
      this.updateproductClass();
    },
    requestSpecAtProductClassModel(productClassModel) {
      if (productClassModel.specs) return;
      this.$set(productClassModel, "specLoading", true);
      let params = {
        ProductNumber: this.productNumber, // 20200520商品编号
        ProductClassId: this.id,
        ParentId: productClassModel.PCModelId,
      };
      this.$api.product
        .loadProductClassModels(params)
        .then((res) => {
          const specs = [];
          let newData = res.data;
          // 新增的要修改PCModelId(规格编号),每个商品的子规格编号唯一20200520
          // console.log(res.data)
          if (!this.productNumber) {
            // 数组去重
            let reduceData = newData;
            let data = reduceData.reduce((total, item, index) => {
              // eslint-disable-next-line no-unused-expressions
              reduceData[item.ModelName]
                ? ""
                : (reduceData[item.ModelName] = true && total.push(item));
              return total;
            }, []);
            // let data = newData按时间修改商品的子规格编号
            newData = data.map((item, index) => {
              let PCModelId = parseInt(
                (Date.now() + "").substr(-6) +
                  ("0000" + Math.floor(Math.random() * 10000)).slice(-4)
              );
              let newItem = item;
              newItem.PCModelId = PCModelId;
              return newItem;
            });
          }
          for (const item of newData) {
            const index = productClassModel.SonClassModels.findIndex((v) => {
              return v.PCModelId === item.PCModelId;
            });
            if (index === -1) {
              specs.push({
                value: item.PCModelId,
                label: item.ModelName,
              });
            }
          }
          this.$set(productClassModel, "specs", specs);
          this.$set(productClassModel, "specLoading", false);
        })
        .catch((err) => {
          console.log(err);
          this.$set(productClassModel, "specLoading", false);
        });
    },
    // 跳转服务条款
    toTerms() {
      this.$router.push("/terms");
    },
    //品牌方法
    brandLogoPhotosChanged(images) {
      this.form.brandLogo = images.map((image) => {
        return image.state === "success" ? image.url : "";
      });
    },
    brandLogoPhotosTop(images) {
      this.form.brandLogo = images.map((image) => {
        return image.state === "success" ? image.origin : "";
      });
    },
    brandAuthPhotosChanged(images) {
      this.form.brandAuthorizationLetter = images.map((image) => {
        return image.state === "success" ? image.url : "";
      });
    },
    brandAuthPhotosTop(images) {
      this.form.brandAuthorizationLetter = images.map((image) => {
        return image.state === "success" ? image.origin : "";
      });
    },
    trademarkPhotosChanged(images) {
      this.form.trademarkRegistrationCertificate = images.map((image) => {
        return image.state === "success" ? image.url : "";
      });
    },
    trademarkPhotosTop(images) {
      this.form.trademarkRegistrationCertificate = images.map((image) => {
        return image.state === "success" ? image.origin : "";
      });
    },
    //认证方法
    attPhotosClick(index) {
      this.currentIndex = index;
    },
    attPhotosChanged(images) {
      setTimeout(() => {
        this.form.productAttestationList[this.currentIndex].AttestationPhoto =
          images.map((image) => {
            return image.state === "success" ? image.url : "";
          });
      }, 100);
    },
    attPhotosTop(images) {
      setTimeout(() => {
        this.form.productAttestationList[this.currentIndex].AttestationPhoto =
          images.map((image) => {
            return image.state === "success" ? image.origin : "";
          });
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>

.head-title {
  display: flex;
  align-items: center;
  color: #22b196;
  font-size: 16px;
  margin-top: 36px;
  margin-bottom: 0;

  > i {
    display: block;
    width: 2px;
    height: 16px;
    background-color:#22b196;
    border-radius: 1px;
    margin-right: 8px;
  }
  span {
    display: inline-block;
    margin-left: 10px;
    font-size: 13px;
    color: #e6a23c;
  }
}
.form-box {
  margin-top: 18px;
  ::v-deep .el-select {
    margin-left: 30px;
  }

  .el-form-item {
    margin-bottom: 6px;
  }

  .breadcrumb.inline {
    display: inline-block;
    margin-right: 16px;
    font-weight: normal;
  }
  ::v-deep .el-input.is-disabled .el-input__inner {
    background-color: #ffffff !important;
    color: #000 !important;
  }
  .textfield {
    display: inline-block;
    width: auto;
    min-width: 300px;
    &.mini {
      width: 80px;
      min-width: 80px;
    }

    &.small {
      min-width: 160px;
    }

    .prefix {
      font-style: normal;
      margin-left: 10px;
      color: black;
    }
    .suffix {
      font-style: normal;
      margin-right: 10px;
      color: black;
    }
  }
  .small-textarea {
    display: inline-block;
    width: auto;
    min-width: 380px;
  }
  .tBUrlInput {
    display: inline-block;
    width: auto;
    min-width: 500px;
  }
  .textareatBUrl {
    word-wrap: break-word;
    width: 70%;
  }
  .red-text {
    font-weight: bold;
    color: red;
  }
  .unit {
    padding: 5px;
  }
  .desc {
    font-size: 12px;
    color: #989898;
    margin-left: 10px;
    &.wrap {
      display: block;
      line-height: 24px;
      margin-left: 0;
    }
  }
  .keyword-tags {
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
    .el-tag + .el-tag {
      margin-left: 10px;
    }
  }
  .button-new-keyword {
    vertical-align: middle;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-keyword {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .gray-box {
    margin-top: 16px;
    padding: 30px 20px;
    background-color: #fbf9f9;
    border-radius: 13px;
  }
  .freight-desc-box {
    font-size: 12px;
    line-height: 12px;
    color: black;

    > p {
      margin-top: 12px;
      margin-bottom: 0;

      span {
        color: #22b196;
      }
    }
  }
  .normal-checkbox {
    font-weight: normal;
  }
  .tag-checkbox-group {
    padding-bottom: 20px;
    border-bottom: 1px dashed #ccc;
  }
  .tag-box + .tag-box {
    margin-top: 20px;
  }
  .att-form-item {
    border-top: 1px dashed #ccc;
    padding-top: 20px;
    margin-top: 20px;
    margin-bottom: 0px;
  }
  .input-new-tag {
    width: 68px;
    margin-left: 25px;
  }
  .button-new-tag {
    margin-left: 25px;
  }
  .checkbox-delete {
    margin-left: 5px;
    background-color: #989898;
    color: white;
    border-radius: 50%;
    text-align: center;
  }
}
.submit-btn {
  min-width: 300px;
  display: block;
  margin: 30px auto 0;
}
.stateBox {
  text-align: center;
  ::v-deep .el-dialog--center {
    border-radius: 16px;
  }
  // ::v-deep .el-dialog--center .el-dialog__body{
  //  text-align: center !important;
  // }
  .stateInfo {
    margin: 0 auto;
    //  text-align: center;
    max-width: 800px;
    font-weight: bold;
    cursor: pointer;
    color: #e6a23c;
    font-size: 18px;
    text-indent: 1em;
  }
  .stateInfo2 {
    margin: 0 auto;
    //  text-align: center;
    max-width: 800px;
    margin-top: 30px;
    cursor: pointer;
    color: #909090;
    text-indent: 1em;
    line-height: 22px;
  }
  .stateInfoBt {
    margin: 0 auto;
    text-align: center;
    background-color: #22b196;

    font-weight: 500;
  }
  .btns {
    width: 100%;
    text-align: center;
    margin-top: 5%;
  }
  .title {
    font-weight: bold;
    font-size: 20px;
  }
}
//
.productEditMc {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 81%;
  right: 0;
  z-index: 3;
  // background-color: #000000;
  opacity: 0.6;
}
</style>
